import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

/**
 * AnimatedCounter — SSR-safe number counter that animates on scroll-into-view.
 *
 * To avoid hydration mismatch with react-snap, during the initial render
 * (server + first client paint), we render the FINAL value statically.
 * After hydration, we switch to the animated CountUp.
 */
const AnimatedCounter = ({ end, duration = 2, suffix = '', prefix = '', decimals = 0 }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Prerender (react-snap) and first client paint show the final number so
  // crawlers never see "0+" in the static HTML.
  const isPrerender = typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);
  if (!hasMounted || isPrerender) {
    return <span>{prefix}{decimals > 0 ? end.toFixed(decimals) : end}{suffix}</span>;
  }

  // After hydration, switch to animated version
  return (
    <span ref={ref}>
      {inView ? (
        <CountUp
          end={end}
          duration={duration}
          suffix={suffix}
          prefix={prefix}
          decimals={decimals}
        />
      ) : (
        <span>{prefix}{decimals > 0 ? end.toFixed(decimals) : end}{suffix}</span>
      )}
    </span>
  );
};

export default AnimatedCounter;
